function modifyProductLdJson(productId) {
  const storeHash = '238197';
  const apiKeyPublic = 'pubkey-BX81CF8AM59vBup1yPqv00134F2M72';
  const perPage = 100;
  const page = 1;

  if (!productId || !storeHash || !apiKeyPublic) return;

  const base = 'https://stamped.io/api/widget/reviews';
  const params = new URLSearchParams({
    productId: String(productId),
    sId: storeHash,
    apiKey: apiKeyPublic,
    per_page: String(perPage),
    page: String(page),
    take: perPage
  });
  const endpoint = `${base}?${params.toString()}`;

  const extractDate = item => {
    const toYMD = d => {
      const dt = new Date(d);
      if (isNaN(dt.getTime())) return undefined;
      const pad2 = n => (n < 10 ? '0' + n : n);
      return `${dt.getUTCFullYear()}-${pad2(dt.getUTCMonth() + 1)}-${pad2(dt.getUTCDate())}`;
    };

    if (item.dateCreated) {
      const ymd = toYMD(item.dateCreated);
      if (ymd) return ymd;
    }
    if (item.reviewDate) {
      const [mm, dd, yyyy] = item.reviewDate.split('/');
      if (yyyy && mm && dd) {
        return toYMD(new Date(Number(yyyy), Number(mm) - 1, Number(dd)));
      }
    }
    return undefined;
  };

  const mapToSchemaReview = r => {
    const out = {
      '@type': 'Review',
      author: { '@type': 'Person', name: r.author.trim() || 'Anonymous' },
      reviewRating: {
        '@type': 'Rating',
        ratingValue: String(r.reviewRating ?? '')
      }
    };

    const datePublished = extractDate(r);
    if (datePublished) out.datePublished = datePublished;
    if (r.reviewMessage.trim()) out.reviewBody = r.reviewMessage.trim();

    return out;
  };

  function getProductJsonLdById() {
    const el = document.getElementById('product-jsonld');
    if (!el) return null;

    try {
      const parsed = JSON.parse(el.textContent.trim());
      if (parsed && parsed['@type'] === 'Product') {
        return { el, jsonRoot: parsed };
      }
      return null;
    } catch {
      return null;
    }
  }

  function insertReviewsIntoLdJson(reviews) {
    const found = getProductJsonLdById();
    if (!found) return false;

    const { el, jsonRoot } = found;
    jsonRoot.review = reviews;

    el.textContent = JSON.stringify(jsonRoot, null, 2);
    return true;
  }

  fetch(endpoint, { method: 'GET', mode: 'cors' })
    .then(res => res.json())
    .then(json => {
      const list = Array.isArray(json?.data) ? json.data : [];
      const reviews = list
        .filter(r => r && r.reviewRating != null)
        .slice(0, perPage)
        .map(mapToSchemaReview);
      insertReviewsIntoLdJson(reviews);
    });
}

document.addEventListener('DOMContentLoaded', () => {
  const loader = document.getElementById('stamped-reviews-loader');
  const pid = loader ? loader.dataset.productId : null;
  modifyProductLdJson(pid);
});
